module.exports = __webpack_public_path__ + "img/pre-tax-monthly-payment-icon.210a104e.svg";